.eds-page-layout {
  min-height: 0;
}

.eds-page-layout--content {
  min-height: 0;
  overflow: auto;
  padding-block: var(--eds--padding-8);
  width: 100%;
}

.eds-page-layout--hosted .eds-page-layout--content {
  padding-block: var(--eds--padding-none);
}

.eds-page-layout--bg-base {
  background: var(--eds--color--bg-base);
}

.eds-page-layout--bg-muted {
  border-top: 1px solid var(--eds--color--border-default);
  background: var(--eds--color--bg-muted-soft);
}
